/**
 * Working-hours helpers.
 *
 * Working hours are a wall-clock start/end stored as "HH:MM" and always
 * interpreted in U.S. Eastern Time (ET) — everyone enters and reads them in the
 * same zone, so there is no per-person zone or viewer conversion.
 */

const TIME_RE = /^(\d{2}):(\d{2})(?::(\d{2}))?$/;

/**
 * Stored 24-hour "09:00[:00]" → 12-hour "9:00 AM"; "17:30" → "5:30 PM".
 * Passes non-time strings through unchanged.
 */
export function formatClock(value: string): string {
  const m = TIME_RE.exec(value);
  if (!m) return value;
  const h24 = Number(m[1]);
  const minute = m[2];
  const meridiem = h24 < 12 ? "AM" : "PM";
  const hour12 = h24 % 12 === 0 ? 12 : h24 % 12;
  return `${hour12}:${minute} ${meridiem}`;
}
